import en from "./en"
import zhCN from "./zh"
export default {
  en,
  'zh-Hans': zhCN
}